import styled from 'styled-components';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import { rem } from '~/src/helpers/rem-converter.helper';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const AddressRequiredPlankContainer = styled.div`
    display: inline-flex;
    min-height: ${rem(36)};
    margin-top: ${rem(24)};
    border-radius: ${BORDER_RADIUS.bigger12};
    background-color: ${COLORS.constantLightestBlackberry};
    align-items: center;
    padding: ${rem(9)} ${rem(13)};
    box-sizing: border-box;
`;

export const Content = styled.div`
    gap: ${rem(9)};
    align-items: center;
    flex-wrap: nowrap;
`;

export const TextPlank = styled.span`
    display: flex;
    ${FONTS.compact.regular.size14};
`;

export const Address = styled.b`
    display: contents;
    ${FONTS.compact.medium.size14};
`;
